import { formatPriceInCents } from '@utils/formatters/number.formatter'

import type { ClassProperties } from 'types/utils'

export enum Currency {
  USD = 'usd',
}

export default class Price {
  public priceInCents: number
  public taxInCents: number
  public currency = Currency.USD

  constructor(props: Partial<ClassProperties<Price>>) {
    this.priceInCents = props.priceInCents ?? 0
    this.taxInCents = props.taxInCents ?? 0
    this.currency = props.currency ?? Currency.USD
  }

  getPrice() {
    return this.priceInCents / 100
  }

  getTotal() {
    return this.priceInCents + this.taxInCents
  }

  getFormattedTax() {
    return formatPriceInCents(this.taxInCents, {
      currency: this.currency,
      showDouble0ForCents: true,
    })
  }

  getFormattedSubTotal() {
    return formatPriceInCents(this.priceInCents, {
      currency: this.currency,
      showDouble0ForCents: true,
    })
  }

  getFormattedTotal() {
    return formatPriceInCents(this.getTotal(), {
      currency: this.currency,
      showDouble0ForCents: true,
    })
  }
}
